import {useEffect, useRef, useState} from 'react';

type UseFieldFocusStyleProp = {tabFocusClass: string; mouseFocusClass: string};
type FocusType = 'tab' | 'mouse';

type UseFieldFocusStyleReturnType = {
  borderClass: string;
  focusHandler: (e: any) => void;
  mouseKeyDownHandler: (e: any) => void;
};

export const useFieldFocusStyle = ({
  tabFocusClass,
  mouseFocusClass,
}: UseFieldFocusStyleProp): UseFieldFocusStyleReturnType => {
  const [filedFocusedType, setFiledFocusedType] = useState<FocusType>('tab');
  const lastInteraction = useRef<FocusType>('mouse');

  const borderClass =
    filedFocusedType == 'tab' ? tabFocusClass : mouseFocusClass;

  const handleMouseDown = () => (lastInteraction.current = 'mouse');
  const handleKeyDown = (event: any) => {
    if (event.key === 'Tab') {
      lastInteraction.current = 'tab';
    }
  };
  const focusHandler = (_e: any) => {
    setFiledFocusedType(lastInteraction.current);
  };
  const mouseKeyDownHandler = (_e: any) => {
    setFiledFocusedType('mouse');
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return {borderClass, focusHandler, mouseKeyDownHandler};
};
